import React, { useState, useEffect } from "react";
import Loading from "../../../Student/Reusablecomponents/Loading";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { HiMiniPlusSmall } from "react-icons/hi2";
import { RiDeleteBin5Line } from "react-icons/ri";
import { FaRegEye } from "react-icons/fa";
import ScenarioQuestionformat from "../../../Student/Reusablecomponents/ScenarioQuestionformat";
import axios from "axios";
import {
  GetQuestionDetails,
  QuestionDelete,
  QuestionPreview,
  GetScienceQuestionDetails,
  GetEnglishQuestionDetails,
  GetEnglishScenarioDetails,
} from "../../../ReusableComponents/CommonApis";
import { QuestionData } from "../../../Redux/Reducers/QBAdmin/EditQuestions";
const FilterQuestion = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const Scenario = useSelector(
    (state) => state.ScenarioDeatils.ScenarioDetails
  );
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectLanguage = useSelector(
    (state) => state.SelectLanguageData.SLanguage
  );
  const [QuestionList, SetQuestionList] = useState();
  const [Load, SetLoad] = useState(false);
  const [DMessage, SetDMessage] = useState();

  const QuestionsByScenarioId = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/QuestionBank/${
            location.state?.Tab === "INQ"
              ? "GetNonMCQQuestionsByScenarioId"
              : "GetQuestionsByScenarioId"
          }?ScenarioID=${location?.state?.SID}&LanguageId=${SelectLanguage}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0]?.questionID) {
          SetQuestionList(res.data);
          props.Count(res.data.length);
        } else {
          SetQuestionList(process.env.REACT_APP_NODATAFOUND);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (items.subjectId === "3" && location.state.Tab === "INQ") {
      GetEnglishScenarioQuestions();
    } else {
      QuestionsByScenarioId();
    }
  }, [DMessage]);

  const GetEnglishScenarioQuestions = async () => {
    SetLoad((prev) => !prev);
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/QuestionBank/GetEnglishDescQuestionsByScenarioId?ScenarioID=${Scenario?.scenarioID}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data[0]?.questionID) {
          SetQuestionList(res.data);
          props.Count(res.data.length);
        } else {
          SetQuestionList(process.env.REACT_APP_NODATAFOUND);
        }
        SetLoad((prev) => !prev);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const NavigatetoAddquestion = () => {
    if (items?.subjectId === "3") {
      GetEnglishScenarioDetails(
        Scenario.scenarioID,
        dispatch,
        navigate,
        SetLoad,
        location
      );
    }else{
      navigate("/QBAdmin/QuestionBank/AddUpdateQuestions", {
      state: { Tab: location.state?.Tab, SID: location.state?.SID },
     });
    }
    dispatch(QuestionData({ QuestionDetails: "" }));
    // SName: location.state?.SName 
    // navigate("/QBAdmin/QuestionBank/AddUpdateQuestions", {
    //   state: { Tab: location.state?.Tab },
    // });
  };

  const GetQDetails = (Qid) => {
    switch (items.subjectId) {
      case "1":
        GetQuestionDetails(
          SelectLanguage,
          Qid,
          dispatch,
          navigate,
          SetLoad,
          location,
          false
        );
        break;
      case "2":
        GetScienceQuestionDetails(
          SelectLanguage,
          Qid,
          dispatch,
          navigate,
          SetLoad,
          location,
          false
        );
        break;
      case "3":
        GetEnglishQuestionDetails(
          Qid,
          dispatch,
          navigate,
          SetLoad,
          location,
          false
        );
        break;
    }
  };

  return (
    <>
      <div className="dflex mt-3 mb-2 alignitems JSBetween">
        <div className="SubHeading">Question bank</div>
        <button className="Buttons AddButton" onClick={NavigatetoAddquestion}>
          {" "}
          <HiMiniPlusSmall /> Add Question{" "}
        </button>
      </div>
      <div className="Card">
        {QuestionList?.[0]?.questionID ? (
          QuestionList?.map((item, index) => (
            <div key={index}>
              <div className="dflex JSBetween">
                <div>
                  <div className="dflex gap-1">
                    <div
                      className="CPointer text-decoration-underline"
                      onClick={() => GetQDetails(item.questionID)}
                    >
                      <b className="text-danger text-decoration-underline" title="Edit Question">
                        {" "}
                        Q:{index + 1}{" "}
                      </b>
                      <span title="Edit Question"> ({item.questionID}) </span>
                    </div>
                    <div>
                      {items?.subjectId === "1" && `- ${item?.isClonedName}`}
                    </div>
                  </div>
                  <ScenarioQuestionformat scenario={item.question} />
                  {item.qType === "M" &&
                    ["A", "B", "C", "D"].map((option, i) => (
                      <div
                        key={i}
                        className="Options"
                        style={
                          option === item.answer
                            ? { color: "green", fontWeight: "bold" }
                            : {}
                        }
                      >
                        <span className="dflex p-1">
                          {option})&nbsp;{" "}
                          <ScenarioQuestionformat
                            scenario={item[`option${option}`]}
                          />
                        </span>
                      </div>
                    ))}
                  <div className="dflex gap-2">
                    <b>Answer :</b>
                    <ScenarioQuestionformat scenario={item.answer} />
                  </div>
                </div>
                <div className="dflex gap-2">
                  <FaRegEye
                    title="Preview"
                    className="CPointer"
                    onClick={() =>
                      QuestionPreview(item, dispatch, navigate, location)
                    }
                  />
                  <RiDeleteBin5Line
                    title="Delete"
                    style={{ color: "#FD3333" }}
                    className="CPointer"
                    onClick={() => {
                      SetDMessage();
                      QuestionDelete(item.questionID, SetDMessage, dispatch);
                    }}
                  />
                </div>
              </div>
              <hr />
            </div>
          ))
        ) : (
          <div className="ErrorMessage"> {QuestionList} </div>
        )}
        <div>
          Click on <b>Q.no</b> to to edit the Question. |{" "}
          <b>** indicates that the LO is not mapped.. .</b>
        </div>
      </div>
      {DMessage?.open && (
        <div className="Model-Open">
          <div className="Card w-50">
            {DMessage?.message}
            <button
              className="Buttons bg-danger"
              style={{ float: "right" }}
              onClick={() => {
                SetDMessage({ open: false });
              }}
            >
              cancel
            </button>
          </div>
        </div>
      )}
      {Load && <Loading />}
    </>
  );
};
export default FilterQuestion;
